
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import {
  getHue,
  delayedBoundsCall,
  useMouseEvents
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";

type Positions = { startX: number; positionX: number };

@Component
export default class Hue extends Vue {
  @Prop()
  hue!: number;

  @Prop()
  saturation!: number;

  @Prop()
  value!: number;

  @Prop()
  updateColor!: Function;

  width = 0;
  mouseEvents: (event: MouseEvent) => void = () => {};

  get offsetLeft() {
    return (((this.hue * this.width) / 360) | 0) - 6;
  }

  get pointerStyle() {
    return {
      left: `${this.offsetLeft}px`
    };
  }

  mounted() {
    delayedBoundsCall(this.calculateBounds);

    this.mouseEvents = useMouseEvents(
      this.mouseDownHandler,
      this.mouseMoveHandler,
      this.mouseUpHandler
    );
  }

  calculateBounds() {
    const hue = this.$refs.hueRef as HTMLElement;

    if (hue) {
      this.width = hue.clientWidth;
    }
  }

  mouseDownHandler(event: MouseEvent) {
    this.calculateBounds();

    const startX = event.pageX;
    const target = event.currentTarget as HTMLElement;
    const elementX = target.getBoundingClientRect().x;
    const positionX = startX - elementX;

    const color = getHue(positionX, this.width, this.saturation, this.value);

    this.updateColor(color, "onStartChange");

    return {
      startX,
      positionX
    };
  }

  changeObjectPositions(event: MouseEvent, { startX, positionX }: Positions) {
    const pageX = event.pageX;
    const moveX = pageX - startX;
    positionX += moveX;

    // update value and saturation
    const offsetX =
      positionX > this.width ? this.width : positionX <= 0 ? 0 : positionX;
    const color = getHue(offsetX, this.width, this.saturation, this.value);

    return {
      positions: {
        positionX,
        startX: pageX
      },
      color
    };
  }

  mouseMoveHandler(event: MouseEvent, { startX, positionX }: Positions) {
    event.preventDefault();

    const { positions, color } = this.changeObjectPositions(event, {
      startX,
      positionX
    });

    this.updateColor(color, "onChange");

    return positions;
  }

  mouseUpHandler(event: MouseEvent, { startX, positionX }: Positions) {
    event.preventDefault();

    const { positions, color } = this.changeObjectPositions(event, {
      startX,
      positionX
    });

    this.updateColor(color, "onEndChange");

    return positions;
  }
}
